import { useState } from "react";
import { TABLET_SIZE } from "../../../../../../core/constants/common";
import { useWindowSize } from "../../../../../../core/hooks/common/useWindowSize";
import FilterLayout from "../../../../../layout/filter/FilterLayout";
import { useGetUserCardHistory } from "../../../../../../core/services/react-query/report/cards";
import { CacheKeys, userCardHistoryOptions } from "../../../../../../core/constants/filter";
import UserCardHistoryTable from "./UserCardHistoryTable";
import { useParams } from "react-router-dom";
import RUserCardHistoryTable from "./RUserCardHistoryTable";
import { PageCard } from "../../../../../../styles/CommonStyles";


const UserCardHistory = () => {
    const params = useParams()

    const { width } = useWindowSize();
    const [userCards, setUserCards] = useState({ loading: true, data: null })
    const onQuerySuccess = (res) => {
        setUserCards(res)
    }

    const Component = width > TABLET_SIZE ? UserCardHistoryTable : RUserCardHistoryTable


    return (
        <PageCard className="pt-20">
            <FilterLayout
                query={useGetUserCardHistory}
                options={userCardHistoryOptions}
                onQuerySuccess={onQuerySuccess}
                cache={CacheKeys.USER_CARD_HISTORY}
                extra={{ cardId: params?.cardId }}
            >
                <Component
                    data={userCards}
                />
            </FilterLayout >
        </PageCard>
    )
}

export default UserCardHistory